import { Component, OnInit, Input, Host, Output, EventEmitter} from '@angular/core';
import { SectionConfig, SummaryConfig, SummaryControlConfig } from "../../../../common/models/flow.dto";
import { Question } from "../../../../flow/models/flow.model";
import { DateService } from "../../../../common/services/date.service";
import { ContextInteractionService } from "../../../services/context-interaction.service";
import { Domain } from "../../../../builder/models/domain.model";
import { FlowComponent } from "../../../../flow/components/flow/flow.component";
import { SummaryComponent } from "../summary.component";

@Component({
    selector: 'summary-flow-view',
    templateUrl: './summary-flow-view.component.html',
    styleUrls: ['../summary.component.scss'],
    standalone: false
})
export class SummaryFlowViewComponent implements OnInit {

    @Input() anyPending: boolean = false;
    @Input() componentContext: any;
    @Input() config: SummaryControlConfig;    
    @Input() displaySections: SectionConfig[];
    @Input() domains: Map<string, Domain[]>;
    @Input() flowComponent: FlowComponent;
    @Input() isPreview: boolean = false;
    @Output() navigate: EventEmitter<SectionConfig> = new EventEmitter<SectionConfig>();
    @Input() reviewStatus: string | null;


    get applicationNumber(): string {
        if (this.flowComponent == null || this.flowComponent.currentFlowIndex == null) return null;
        let applicationNumber = Object.prototype.hasOwnProperty.call(this.flowComponent.currentFlowIndex, 'applicationNumber')
            ? (this.flowComponent.currentFlowIndex as any).applicationNumber
            : this.flowComponent.currentFlowIndex.flowIdentifier;
        return applicationNumber;
    }

    get organizationName(): string {
        if (this.flowComponent == null || this.flowComponent.currentFlowIndex == null) return null;
        return this.flowComponent.currentFlowIndex.companyName;
    }

    get hasWellName(): boolean {
        if (this.flowComponent == null || this.flowComponent.currentFlowIndex == null) return false;
        if (Object.prototype.hasOwnProperty.call(this.flowComponent.currentFlowIndex, "wellName")) {
            let value = this.flowComponent.currentFlowIndex['wellName'];
            return (value != null && value.length != null && value.length > 0);
        } else {
            return false;
        }
    }

    get hasWellNumber(): boolean {
        if (this.flowComponent == null || this.flowComponent.currentFlowIndex == null) return false;
        if (Object.prototype.hasOwnProperty.call(this.flowComponent.currentFlowIndex, "wellNumber")) {
            let value = this.flowComponent.currentFlowIndex['wellNumber'];
            return (value != null && value.length != null && value.length > 0);
        } else {
            return false;
        }
    }

    get showAll(): boolean {
        return this.hasWellName == true && this.hasWellNumber == true;
    }

    get showApplicationNumberAndCompanyOnly(): boolean {
        return this.hasWellName == false && this.hasWellNumber == false;
    }

    get wellName(): string {
        if (this.flowComponent == null || this.flowComponent.currentFlowIndex == null) return null;
        let wellName = (this.hasWellName) ? (this.flowComponent.currentFlowIndex as any).wellName : "";
        return wellName;
    }

    get wellNumber(): string {
        if (this.flowComponent == null || this.flowComponent.currentFlowIndex == null) return null;
        let wellNumber = (this.hasWellNumber) ? (this.flowComponent.currentFlowIndex as any).wellNumber : "";
        return wellNumber;
    }


    constructor(
        public dateService: DateService,
        public contextService: ContextInteractionService) {

    }

    ngOnInit() {
    }

    canShowNote(question: SummaryConfig): boolean {
        if (this.flowComponent) {
            return this.flowComponent.canShowNote({ type: question.type, contextTarget: question.contextValue } as Question);
        }
        return false;
    }

    getContextData(target: string): any {
        return this.contextService.getContextData(target, this.componentContext);
    }

    getFiles(question: SummaryConfig): any {
        let files = this.getContextData(question.contextValue);
        if (files) {
            return files.files;
        }
        return [];
    }

    getLinkText(): string {
        let text = "Edit";
        if (this.config != null) {
            if (this.config.isEjectSummary) {
                text = "";
            } else if (this.config.isReviewForm) {
                text = "View";
            }
        }
        return text;
    }

    getNoteIcon(context: string): string {
        if (this.flowComponent) {
            return this.flowComponent.getNoteIcon(context);
        }
        return "";
    }

    getQuestionValue(question: SummaryConfig, target: string): any {
        let value = "";
        let displayValue = undefined;
        if (this.componentContext && target) {
            const data = this.getContextData(target);
            if (data == null) return "";
            if (typeof (data) === 'object') {
                value = data.value;
                displayValue = data.displayValue;
            } else {
                value = data;
            }            

            if (!value && question.isPending) {
                value = "Missing";
            } else if (displayValue != null) {
                value = displayValue;
            }
        }
        return value;
    }

    navigateSection(section: SectionConfig): void {
        this.navigate.emit(section);
    }
   
}
